import type { ReactNode } from 'react';

import { ProviderComposerForTests } from 'containers/ProviderComposer/ProviderComposerForTests';

export const componentsMock = [
  {
    component: 'BannerV2',
    layout: {},
    options: {
      visibility: 'todos',
      image: {
        dimensions: {
          width: 1920,
          height: 1452,
        },
        alt: null,
        copyright: null,
        url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZxvMu4F3NbkBYCye_BOT_C15_24_BANNER_PORTAL_4_CORPO_E_BANHO_CEREJA_ROUGE_2.jpg?auto=format,compress&rect=0,0,480,363&w=1920&h=1452',
        id: 'ZxvMu4F3NbkBYCye',
        edit: {
          x: 0,
          y: 0,
          zoom: 1,
          background: 'transparent',
        },
        desktop: {
          dimensions: {
            width: 1024,
            height: 245,
          },
          alt: null,
          copyright: null,
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZxvLooF3NbkBYCxy_BOT_C15_24_BANNER_PORTAL_1_CORPO_E_BANHO_CEREJA_ROUGE_2.jpg?auto=format,compress&rect=0,0,1920,459&w=1024&h=245',
          id: 'ZxvLooF3NbkBYCxy',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
        tablet: {
          dimensions: {
            width: 768,
            height: 581,
          },
          alt: null,
          copyright: null,
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZxvMu4F3NbkBYCye_BOT_C15_24_BANNER_PORTAL_4_CORPO_E_BANHO_CEREJA_ROUGE_2.jpg?auto=format,compress&rect=0,0,480,363&w=768&h=581',
          id: 'ZxvMu4F3NbkBYCye',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
        mobile: {
          dimensions: {
            width: 480,
            height: 363,
          },
          alt: null,
          copyright: null,
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZxvMu4F3NbkBYCye_BOT_C15_24_BANNER_PORTAL_4_CORPO_E_BANHO_CEREJA_ROUGE_2.jpg?auto=format,compress&rect=0,0,480,363&w=480&h=363',
          id: 'ZxvMu4F3NbkBYCye',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
      },
      linkPortal: {
        linkType: 'Any',
      },
      linkApp: {
        linkType: 'Any',
      },
      action: {},
    },
    tracking: {},
    pagination: null,
    items: [],
  },
  {
    component: 'DividerV2KeyTitle',
    layout: {},
    options: {
      visibility: 'todos',
      alternateColor: true,
      title: 'Juntos, nossa beleza é Multi',
      content: [],
      action: {},
    },
    tracking: {},
    pagination: null,
    items: [],
  },
  {
    component: 'TextBlockV2',
    layout: {},
    options: {
      visibility: 'todos',
      alternateColor: true,
      content: [
        {
          type: 'heading1',
          text: 'Teste',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam convallis volutpat magna, a volutpat justo vestibulum ac. Praesent euismod mattis elementum. Sed dictum ante vitae neque elementum ultricies. Praesent convallis enim sit amet nisi semper, iaculis aliquet ante ornare. Nam dictum mi sed felis tristique, quis mollis leo elementum. Aliquam vulputate malesuada arcu pellentesque tristique. Donec mi magna, vehicula eget porttitor sed, lobortis ac risus. Ut vitae fermentum lacus.',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: '',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: '',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'o-list-item',
          text: 'Teste',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'o-list-item',
          text: 'Teste',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: '',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'list-item',
          text: 'Teste',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'list-item',
          text: 'Teste',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: '',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: 'Teste',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: '\nTeste 2',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'paragraph',
          text: 'Maecenas elementum placerat nibh eget eleifend. Morbi sollicitudin magna quis velit dictum interdum. Ut venenatis ut felis ut rhoncus. Praesent nulla neque, condimentum in ipsum sed, aliquet molestie lorem. Nulla semper tincidunt nisl, sit amet fringilla libero finibus vel. Pellentesque fermentum purus tortor, ac tincidunt enim euismod sed. Curabitur elementum placerat quam, vel bibendum nunc iaculis in. Suspendisse ultrices molestie sapien ac volutpat. Fusce quis elit neque. Phasellus efficitur viverra felis, mollis mollis nibh sodales quis. Suspendisse mi ante, luctus quis dapibus non, placerat in nibh. Maecenas molestie dapibus ipsum, quis eleifend lorem. Sed sollicitudin elementum lectus, eu aliquet magna lacinia eget. Pellentesque ut semper ex.',
          spans: [
            {
              start: 0,
              end: 27,
              type: 'strong',
            },
            {
              start: 408,
              end: 437,
              type: 'em',
            },
            {
              start: 733,
              end: 745,
              type: 'hyperlink',
              data: {
                linkType: 'Web',
                url: 'https://revendedor.boticario.com.br/departamentos',
                target: '_self',
              },
            },
          ],
          direction: 'ltr',
        },
      ],
      action: {},
    },
    tracking: {},
    pagination: null,
    items: [],
  },
  {
    component: 'DividerV2',
    layout: {},
    options: {
      visibility: 'todos',
      alternateColor: true,
      size: 'medium',
      action: {},
    },
    tracking: null,
    pagination: null,
    items: [],
  },
  {
    component: 'CompoundSectionV2',
    layout: {},
    options: {
      visibility: 'todos',
      alternateColor: false,
      reverse: false,
      image: {
        dimensions: {
          width: 1080,
          height: 1350,
        },
        alt: null,
        copyright: null,
        url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZwbW94F3NbkBXG2-_BOT_C15_24_CARD_CF_11_LANCAMENTO_CEREJA_ROUGE_MAKE.jpg?auto=format,compress',
        id: 'ZwbW94F3NbkBXG2-',
        edit: {
          x: 0,
          y: 0,
          zoom: 1,
          background: 'transparent',
        },
        desktop: {
          dimensions: {
            width: 1024,
            height: 1280,
          },
          alt: null,
          copyright: null,
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZwbW94F3NbkBXG2-_BOT_C15_24_CARD_CF_11_LANCAMENTO_CEREJA_ROUGE_MAKE.jpg?auto=format,compress&rect=0,0,1080,1350&w=1024&h=1280',
          id: 'ZwbW94F3NbkBXG2-',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
        tablet: {
          dimensions: {
            width: 768,
            height: 960,
          },
          alt: null,
          copyright: null,
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZwbW94F3NbkBXG2-_BOT_C15_24_CARD_CF_11_LANCAMENTO_CEREJA_ROUGE_MAKE.jpg?auto=format,compress&rect=0,0,1080,1350&w=768&h=960',
          id: 'ZwbW94F3NbkBXG2-',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
        mobile: {
          dimensions: {
            width: 480,
            height: 600,
          },
          alt: null,
          copyright: null,
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZwbW94F3NbkBXG2-_BOT_C15_24_CARD_CF_11_LANCAMENTO_CEREJA_ROUGE_MAKE.jpg?auto=format,compress&rect=0,0,1080,1350&w=480&h=600',
          id: 'ZwbW94F3NbkBXG2-',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
      },
      title: 'Você comprovadamente mais irresistível',
      content: [
        {
          type: 'paragraph',
          text: 'Conheça o novo Nativa SPA Cereja Rouge — um convite para você explorar a máxima potência da sua sensualidade. Descubra o efeito pele de cereja e as notas licorosas do exclusivo acorde sexy cherry, que te deixa comprovadamente mais irresistível. ',
          spans: [],
          direction: 'ltr',
        },
        {
          type: 'image',
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZwlZFoF3NbkBXVJ6_BOT_C15_24_BANNER_PORTAL_4_CORPO_E_BANHO_CEREJA_ROUGE.jpg?auto=format,compress',
          alt: null,
          copyright: null,
          dimensions: {
            width: 480,
            height: 363,
          },
          id: 'ZwlZFoF3NbkBXVJ6',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
        {
          type: 'paragraph',
          text: 'Sinta na pele o poder da perfumação e a hidratação do extrato de cereja e do óleo de quinoa, que garantem uma pele mais firme e suave ao toque. Experimente a nova linha #NativaSPACereja Rouge e ative o seu #MoodSexyCherry para viver a máxima potência da sua sensualidade e sedução, com o toque poderoso e irresistível da cereja.',
          spans: [
            {
              start: 169,
              end: 185,
              type: 'em',
            },
            {
              start: 169,
              end: 185,
              type: 'hyperlink',
              data: {
                linkType: 'Web',
                url: 'https://www.youtube.com/hashtag/nativaspacereja',
                target: '',
              },
            },
            {
              start: 169,
              end: 185,
              type: 'strong',
            },
            {
              start: 206,
              end: 221,
              type: 'em',
            },
            {
              start: 206,
              end: 221,
              type: 'hyperlink',
              data: {
                linkType: 'Web',
                url: 'https://www.youtube.com/hashtag/moodsexycherry',
                target: '',
              },
            },
            {
              start: 206,
              end: 221,
              type: 'strong',
            },
          ],
          direction: 'ltr',
        },
      ],
      buttonText: 'Conheça já',
      linkPortal: {
        linkType: 'Web',
        url: 'https://www.youtube.com/watch?v=1nkTmz-wV04&feature=youtu.be',
      },
      linkApp: {
        linkType: 'Any',
      },
      action: {},
    },
    tracking: {},
    pagination: null,
    items: [],
  },
  {
    component: 'VideoV2',
    layout: {},
    options: {
      visibility: 'todos',
      alternateColor: false,
      link: {
        linkType: 'Web',
        url: 'https://youtube.com/shorts/pmO46qEKSxI?si=0IIulzNFdfNJKG1k',
      },
      action: {},
    },
    tracking: {},
    pagination: null,
    items: [],
  },
  {
    component: 'CarrosselV2',
    layout: {},
    options: {
      visibility: 'todos',
      alternateColor: false,
      infinity: true,
      slidesToShow: '4',
      documentLink: {
        linkType: 'Document',
      },
      action: {},
    },
    tracking: {},
    pagination: null,
    items: [
      {
        image: {
          dimensions: {
            width: 1080,
            height: 1920,
          },
          alt: null,
          copyright: null,
          url: 'https://hvd-starlink-assets.grupoboticario.com.br/re-boticario/ZqASGh5LeNNTxb8W_Q_C11_24_CARD_RELANCAMENTO_VOLUMAO.jpg?auto=format,compress',
          id: 'ZqASGh5LeNNTxb8W',
          edit: {
            x: 0,
            y: 0,
            zoom: 1,
            background: 'transparent',
          },
        },
        name: null,
        linkPortal: {
          linkType: 'Web',
          url: 'https://revendedor.boticario.com.br/departamentos',
        },
        linkApp: {
          linkType: 'Any',
        },
        trackingEventBot: null,
        trackingEventEud: null,
      },
    ],
  },
  {
    component: 'CarrosselV2WithTitle',
    layout: {},
    options: {
      visibility: 'todos',
      card: true,
      alternateColor: false,
      title: 'Seção especial',
      description: 'Descrição essencial',
      infinity: false,
      slidesToShow: '4',
      documentLink: {
        id: 'ZyIjCxIAACIAhKT8',
        type: 'destaques_do_ciclo',
        tags: [],
        lang: 'pt-br',
        slug: 'teste-construtor-de-conteudos',
        firstPublicationDate: '2024-10-30T12:14:16+0000',
        lastPublicationDate: '2024-10-30T20:47:24+0000',
        linkType: 'Document',
        isBroken: false,
      },
      action: {},
    },
    tracking: {},
    pagination: null,
    items: [],
  },
];

export const ComponentWithMockProvider = ({ children }: { children: ReactNode }) => (
  <ProviderComposerForTests>{children}</ProviderComposerForTests>
);
